/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-01-06 18:10:00
 */

import cameraAlarm from '../cameraAlarm';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import CameraAlarmApi, { CameraAlarmDOI } from '../api/cameraAlarmApi';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import Viewer from 'viewerjs'
import Input from 'src/types/iview/Input';
import EnumStationType from 'src/enums/enumStationType';
export default class CameraAlarmService extends ListPageService {
    ctx: cameraAlarm;

    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

    constructor(ctx: cameraAlarm) {
        super();
        this.ctx = ctx;
    }


    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '站点名称',
                field: 'name',
                minWidth: 150,
            },
            {
                headerName: 'ip地址',
                field: 'ip',
                minWidth: 120,
            },
            {
               headerName: '图片',
               field: 'img',
               minWidth: 250,
               cellRenderer: function(params){
                   let url = params.value;
                   var imageElement = document.createElement("img");
                   imageElement.src = url;
                   imageElement.style.width = 200+'px';
                   imageElement.style.height = 120+'px';
                   return imageElement;
               },
               onCellClicked: function(event) {
                   let container = document.createElement('div');
                   let img = document.createElement('img')
                   img.src = event.data.img
                   container.append(img)
                   var viewer = new Viewer(container, {
                       hidden: function () {
                           viewer.destroy();
                       },
                       toolbar:{
                           zoomIn: true,
                           zoomOut: true,
                           oneToOne: true,
                           reset: true,
                           prev: true,
                           play: true,
                           next: true,
                           rotateLeft: true,
                           rotateRight: true,
                       }
                   });
                   viewer.show();
               },
           },
           {
                headerName: '备注',
                field: 'remarks',
                minWidth: 180,
            },
            {
                headerName: '时间',
                field: 'create_time',
                minWidth: 180,
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: Input,
                label: '站点名称：',
                field: 'name',
                labelWidth: 100,
                width: 300,
                props: { value: '', placeholder: '请输入' },
            },
        ];
    }


    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<CameraAlarmDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        ag.rowHeight = 130;
        let { code, data } = await CameraAlarmApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
